import BasicTooltip from './BasicTooltip';
import ClickModeTooltip from './ClickModeTooltip';
import { TooltipProps } from './types';

const Tooltip: React.FC<React.PropsWithChildren<TooltipProps>> = ({
  isDisabled,
  isClickMode,
  children,
  ...rest
}) => {
  if (isDisabled) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }

  if (isClickMode) {
    return <ClickModeTooltip {...rest}>{children}</ClickModeTooltip>;
  }

  return <BasicTooltip {...rest}>{children}</BasicTooltip>;
};

export default Tooltip;
